export default __webpack_public_path__ + "static/media/DSC_8052.e1f5e67e.jpg";